<div class="flex" [class]="className">
  <svg-icon class="w-8 h-8 inline-block mt-2 mr-3 flex-shrink-0" [src]="src"></svg-icon>
  <div>
    <ng-content></ng-content>
  </div>
</div>
